<template lang='pug'>
  bf-overlay.flush(
    v-if='rsv'
    :user='user',
    :account='account',
    :biz='biz',
    :data='rsv',
    @close='rsv = false'
  )
    template(v-slot:heading)
      h5 {{ $t('Reservation/Appointment Details') }}

    #rsv-dtls.container
      rsv-dtls.overlay(
        v-if='rsv'
        :rsv='rsv'
      )
    rsv-msgs#rsv-msgs(
      v-if='rsv && account'
      :rsv='rsv'
      :account='account'
      :key='rsv.id'
    )
    
  base-card.customer-card.component(v-else @click.native='show.history = true')
    .cover( v-show='!cus.account_id' )
    bf-flex.container.centered
      img.avatar( :src='avatar' )
      .details
        .name.ellipsis {{ cus.account.username || cus.name }} 
          span(v-if="favor.length") 
            img(src='/ui/heart.svg')
        .address.ellipsis {{ cus.address }}
        .email.ellipsis {{ cus.email || cus.phone }}

      .attrs
        select( @click.stop='' v-model='customer.filter' @change='update' )
          option( :value='undefined' ) {{ $t("Category")}}
          option( v-for='f in filters' :value='f' ) {{ f.title }}

        select( @click.stop='' v-model='customer.category' @change='update' )
          option( :value='undefined') {{ $t("Level")}}
          option( value='' ) {{$t("Regular")}}
          option( value='VIP' ) VIP
          option( value='Blacklist' ) {{ $t("Blacklist")}}

      .delete(
        v-show='!show.history'
        @click.stop='remove'
      )
        delete-icon
      .close(
        v-show='show.history'
        @click.stop='show.history = false'
      )
        up-icon
    section(v-show='show.history')
      .visit.info
        p {{$t("Total Visits")}}: {{ rsvs.length }} 
        p {{$t("Visits Last 30 days")}}: {{ prev.length }}
        p {{$t("Last Visited")}}: {{ last ? last.datetime.start.toDate().toLocaleDateString() : $t('None') }}

      table(v-if='rsvs.length')
        thead
          tr
            th {{ $t('Date') }}
            th {{ $t('Time') }}
            th {{ $t('Details') }}
        tbody
          tr(
            v-for='r in sorted.reverse()'
            :class='{ inactive: r.status == "Canceled" }'
          )
            td.time(:class='{ inactive: r.status == "Canceled" }') {{ r.datetime.start.toDate().toLocaleDateString() }}
            td.time(:class='{ inactive: r.status == "Canceled" }') {{ r.datetime.start.toDate().toLocaleTimeString( [], { hour: '2-digit', minute: '2-digit' } ) }}
            td(
              :class='{ inactive: r.status == "Canceled" }'
              @click='view(r)'
            )
              a {{ r.service.title }}
</template>

<script>
  import { db } from '@/main'
  import BaseCard from '@/components/base-card'

  export default {
    name: 'customer-card.component',

    components: {
      BaseCard
    },

    props: ['biz', 'cus', 'user', 'account', 'filters'],

    data() {
      return {
        rsv: null,
        show: { history: false },
        reservations: [],
        customer: this.cus,
        acc: {}
      }
    },

    firestore() {
      if ( this.cus.account_id ) return {
        reservations: {
          ref: db.collection('reservations').where( 'business_id', '==', this.biz.id ).where( 'account_id', '==', this.cus.account_id)
        },
        favor: {
          ref: db.collection('favorites').where( 'business_id', '==', this.biz.id ).where( 'account_id', '==', this.cus.account_id)
        },
        acc: {
          ref: db.collection( 'accounts' ).doc( this.cus.account_id )
        }
      }
      else return {
        reservations: {
          ref: db.collection('reservations').where( 'business_id', '==', this.biz.id ).where( 'account_id', '==', this.cus.account_id)
        },
        favor: {
          ref: db.collection('favorites').where( 'business_id', '==', this.biz.id ).where( 'account_id', '==', this.cus.account_id)
        }
      }
    },

    computed: {
      avatar() {
        return this.acc.avatar || '/no-avatar.png'
      }, 

      rsvs() {
        return this.reservations.filter( r => r.account_id == this.cus.account_id )
      },

      sorted() {
        // this sorts the rsvs by oldest to newest, date ascending.
        return this.rsvs.sort( (r0, r1) => r0.datetime.end.toDate() - r1.datetime.end.toDate() )
      },

      last() {
        let prev = this.infinity
        return prev[prev.length - 1]
      },

      infinity() {
        let today = new Date()
        return this.sorted.filter( r =>
          r.datetime.start.toDate() < today
        )
      },

      prev() {
        let today = new Date()
        let last = new Date()
        last.setDate( today.getDate() - 30 )
        return this.sorted.filter( r =>
          r.datetime.start.toDate() < today  &&
          r.datetime.start.toDate() > last
        )
      }
    },

    methods: {
      filterize() {
        // console.log(this.customer)
      },

      remove() {
        db.collection( 'customers' ).doc( this.cus.id ).delete()
      },

      update() {
        db.collection( 'customers' ).doc( this.cus.id ).update( this.customer )
      },

      view(r) {
        this.rsv = r
      }
    }
  }
</script>

<style scoped lang='stylus'>
  .time
    font-family monospace
    font-size 1.25em

  .bf-overlay.flush
    padding 12px

  a
    color var(--clr-blue-light)
    border-bottom 1px dotted

  .visit.info
    color black
    font-weight bold
    padding 8px 24px
    line-height 1.5

  table
    margin-top 16px
    width 100%
    thead
      font-weight bold
    tbody
      // font-size .92em
    tr.inactive
      // background rgba( 0 0 0 .08 )
    th, td
      padding 12px 16px
      text-align left
      &:last-child
        text-align right
    td
      border-top 1px solid rgba( 0 0 0 .05 )
    td.inactive
      position relative
      &::before
        content ''
        position absolute
        border-top 1px solid red
        width 100%
        height 50%
        left 0
        bottom 0
        background rgba( 0 0 0 .05 )
      &::after
        content ''
        position absolute
        border-bottom 1px solid red
        width 100%
        height 50%
        left 0
        top 0
        background rgba( 0 0 0 .05 )

  .customer-card
    &:hover, &:focus
      background rgb( 255 255 255)
      box-shadow var(--shadow-box)
    background rgb(245 245 255)
    position relative
    margin 16px 0
    @media(max-width: 480px)
      font-size .92em
    &:first-child
      margin-top 0
    .container
      padding 12px
    section
      margin-top 16px
    .cover
      position absolute
      top -1px
      left 0
      border-radius 12px
      height 100.5%
      width 100%
      background rgba( 240 240 240 .64 )
      z-index 1
    .delete, .close
      font-size 1.25em
      position relative
      margin-bottom auto
      z-index 2
    .close
      top -4px
      background orange
      color white
      border-radius 5px
      padding 2px
    .avatar
      width 30px
      height 30px
      border-radius 50%
      @media(min-width: 640px)
        width 50px
        height 50px
    .details
      color black
      font-weight bold
      margin-left 16px
      @media(min-width: 480px)
        font-size 1.1em
    .attrs
      margin-left auto
      text-align right !important
      margin-right 16px
      select
        display block
        padding 0
        margin-left 0

        &:first-child
          margin-bottom 8px
</style>
